import gsap from 'gsap';

const wiggleTimers = new Map();

export function startRandomWiggle(target) {
  if (!target) return;
  const { utils } = gsap;
  stopRandomWiggle(target);
  const startDelay = utils.random(0.5, 5, 0.1);
  const initialCall = gsap.delayedCall(startDelay, () => {
    const wiggle = () => {
      const delay = utils.random(0.5, 5, 0.1);
      const durationTime = 0.15;
      const repeatCount = 2;
      gsap.fromTo(target, { rotation: -15 }, {
        rotation: -45, duration: durationTime, yoyo: true, repeat: repeatCount,
        ease: 'power1.inOut',
        onComplete: () => {
          gsap.to(target, { rotation: -15, duration: durationTime, ease: 'power2.out' });
          const nextCall = gsap.delayedCall(delay, wiggle);
          wiggleTimers.set(target, nextCall);
        }
      });
    };
    wiggle();
  });
  wiggleTimers.set(target, initialCall);
}

export function stopRandomWiggle(target) {
  if (!target) return;
  const timer = wiggleTimers.get(target);
  if (timer) {
    timer.kill();
    wiggleTimers.delete(target);
  }
  gsap.killTweensOf(target);
  gsap.set(target, { rotation: -15 });
}
